"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToArray = exports.getANGHighlight = exports.getScores = exports.getLatestHits = exports.getANGNode = exports.getProp = exports.getANGTypes = void 0;
exports.getInstanceProps = getInstanceProps;
const memoize_one_1 = __importDefault(require("memoize-one"));
const semver_1 = __importDefault(require("semver"));
const keys_1 = require("./keys");
exports.getANGTypes = (0, memoize_one_1.default)((types, assetTypesConfiguration, fixedTypes = []) => {
    let finalTypes = types !== null && types !== void 0 ? types : [];
    if (fixedTypes.length > 0) {
        finalTypes = fixedTypes.filter((fixedType) => finalTypes.some((type) => type === fixedType));
    }
    return finalTypes
        .map((queryType) => { var _a; return (_a = assetTypesConfiguration[queryType]) === null || _a === void 0 ? void 0 : _a.angType; })
        .filter((angType) => angType)
        .reduce((accum, current) => {
        if (accum.indexOf(current) > -1) {
            return accum;
        }
        return [...accum, current];
    }, []);
});
const getProp = (object, prop) => {
    if (!object || !object[prop]) {
        return null;
    }
    return object[prop].sort()[0];
};
exports.getProp = getProp;
exports.getANGNode = (0, memoize_one_1.default)((source, containerName, node) => {
    const container = source[containerName];
    if (!container) {
        return null;
    }
    return Object.keys(container).reduce((accum, key) => {
        if (key.startsWith(`${node}.`)) {
            const responseKey = key.substring(node.length + 1);
            return Object.assign(Object.assign({}, accum), { [responseKey]: container[key] });
        }
        return accum;
    }, {});
});
const getSemverVersion = (hit) => {
    const source = hit[keys_1.SOURCE_KEY];
    const versionNode = (0, exports.getANGNode)(source, 'asset-minor-versions', 'VersionNode');
    return (0, exports.getProp)(versionNode, 'semverVersion');
};
const getPropByPath = (object, path) => {
    return path.reduce((accum, current) => {
        if (accum && accum[current]) {
            return accum[current];
        }
        return null;
    }, object);
};
const getInnerHits = (hit, collapse) => getPropByPath(hit, [keys_1.INNER_HITS_KEY, collapse, 'hits', 'hits']) || [];
const getLatestHits = (hit, collapse = 'ga') => {
    const innerHits = getInnerHits(hit, collapse);
    const latestHit = innerHits.reduce((latestMinorHit, innerHit) => {
        if (!latestMinorHit) {
            return innerHit;
        }
        const semverVersion = getSemverVersion(innerHit);
        const latestSemverVersion = getSemverVersion(latestMinorHit);
        if (semver_1.default.gt(semverVersion, latestSemverVersion)) {
            return innerHit;
        }
        return latestMinorHit;
    }, null);
    return latestHit || hit;
};
exports.getLatestHits = getLatestHits;
const getScores = (hit, collapse = 'ga') => {
    const innerHits = getInnerHits(hit, collapse);
    let latestSemverVersion;
    let latestVersionScore;
    if (!innerHits.length) {
        latestSemverVersion = getSemverVersion(hit);
        latestVersionScore = hit[keys_1.SCORE_KEY];
        return {
            count: 1,
            versions: {
                [latestSemverVersion]: latestVersionScore
            },
            latestVersionScore
        };
    }
    const versions = innerHits.reduce((accum, innerHit) => {
        const semverVersion = getSemverVersion(innerHit);
        if (!latestSemverVersion || semver_1.default.gt(semverVersion, latestSemverVersion)) {
            latestSemverVersion = semverVersion;
        }
        return Object.assign(Object.assign({}, accum), { [semverVersion]: innerHit[keys_1.SCORE_KEY] });
    }, {});
    latestVersionScore = versions[latestSemverVersion] || null;
    return { count: innerHits.length, versions, latestVersionScore };
};
exports.getScores = getScores;
exports.getANGHighlight = (0, memoize_one_1.default)((highlight, containerName, node) => {
    if (!highlight) {
        return null;
    }
    const startingKey = `${containerName}.${node}.`;
    return Object.keys(highlight).reduce((accum, key) => {
        if (key.startsWith(startingKey)) {
            const responseKey = key.substring(startingKey.length);
            return Object.assign(Object.assign({}, accum), { [responseKey]: highlight[key] });
        }
        return accum;
    }, {});
});
function getDescriptors(prototype) {
    const descriptors = Object.getOwnPropertyDescriptors(prototype);
    const extendingPrototype = Object.getPrototypeOf(prototype);
    if (extendingPrototype !== Object.prototype) {
        return Object.assign(Object.assign({}, descriptors), getDescriptors(extendingPrototype));
    }
    return descriptors;
}
/**
 * Get all getter props from a class instance
 *
 * @param instance
 */
function getInstanceProps(instance) {
    const prototype = Object.getPrototypeOf(instance);
    const descriptors = getDescriptors(prototype);
    const getters = Object.keys(descriptors).filter((descriptorKey) => !!descriptors[descriptorKey].get);
    const result = getters.reduce((accum, current) => (Object.assign(Object.assign({}, accum), { [current]: instance[current] })), {});
    return result;
}
const convertToArray = (objectOrArray) => {
    if (!objectOrArray) {
        return [];
    }
    if (Array.isArray(objectOrArray)) {
        return objectOrArray;
    }
    return [objectOrArray];
};
exports.convertToArray = convertToArray;
